import _pt from "prop-types";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/* eslint-disable @typescript-eslint/unbound-method */
import React from 'react';
import cx from 'classnames';
import { arc as d3Arc } from 'd3-shape';
import setNumOrAccessor from '../util/setNumberOrNumberAccessor';
export default function Arc(_ref) {
  var className = _ref.className,
    data = _ref.data,
    innerRadius = _ref.innerRadius,
    outerRadius = _ref.outerRadius,
    cornerRadius = _ref.cornerRadius,
    startAngle = _ref.startAngle,
    endAngle = _ref.endAngle,
    padAngle = _ref.padAngle,
    padRadius = _ref.padRadius,
    children = _ref.children,
    innerRef = _ref.innerRef,
    restProps = _objectWithoutPropertiesLoose(_ref, ["className", "data", "innerRadius", "outerRadius", "cornerRadius", "startAngle", "endAngle", "padAngle", "padRadius", "children", "innerRef"]);
  var arc = d3Arc();
  if (innerRadius != null) setNumOrAccessor(arc.innerRadius, innerRadius);
  if (outerRadius != null) setNumOrAccessor(arc.outerRadius, outerRadius);
  if (cornerRadius != null) setNumOrAccessor(arc.cornerRadius, cornerRadius);
  if (startAngle != null) setNumOrAccessor(arc.startAngle, startAngle);
  if (endAngle != null) setNumOrAccessor(arc.endAngle, endAngle);
  if (padAngle != null) setNumOrAccessor(arc.padAngle, padAngle);
  if (padRadius != null) setNumOrAccessor(arc.padRadius, padRadius);
  if (children) return /*#__PURE__*/React.createElement(React.Fragment, null, children({
    path: arc
  }));
  if (!data) return null;
  return /*#__PURE__*/React.createElement("path", _extends({
    ref: innerRef,
    className: cx('vx-arc', className),
    d: arc(data) || ''
  }, restProps));
}
Arc.propTypes = {
  className: _pt.string,
  children: _pt.func,
  innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object])
};